/* eslint-disable no-unused-vars */
export var ToastStyle;
(function (ToastStyle) {
    ToastStyle[ToastStyle["Neutral"] = 0] = "Neutral";
    ToastStyle[ToastStyle["Success"] = 1] = "Success";
    ToastStyle[ToastStyle["Error"] = 2] = "Error";
})(ToastStyle || (ToastStyle = {}));
